module.exports = __webpack_public_path__ + "img/login-view.9db51f65.svg";